import type { FaireProductEntity } from "../../entity_types/product";

export const p_4agf3e90m1: FaireProductEntity = {
  token: "p_4agf3e90m1",
  type: "product",
  name: "PINEAPPLE GALORE TAMALITOZ CANDY 12CT",
  brandToken: "b_3pi3q87y4r",
  brandName: "Sugarox Candy Studio LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/1eecf39695a00dff48ecdf8a7bbc92cb4e63ce1756002efaf847f81b39fc4381.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3119b5d127b6404083acd4460a500a39fc7a610071d8b9295c8c6af82a89e990.png",
    "https://cdn.faire.com/fastly/e4e59602f10bb7fb74bd40e4ccf8e6b0439ff1556ecfa8b47ccb815aafb73fcd.png",
    "https://cdn.faire.com/fastly/199aa1226ac6fd0775f98279b2698fcedf3e6b311c835d7aa05a1bd23a89eb88.png",
    "https://cdn.faire.com/fastly/34b21c495c4035685fc769b21dae5d3e238ad776d8911301610cfe534a8b574b.jpeg",
    "https://cdn.faire.com/fastly/5179f3c01a075a4af11902b4848c3de4e1705117e31b115c8cf07335fedd87eb.jpeg",
    "https://cdn.faire.com/fastly/322d26e8ef4a0b1cf952125f2541d46efbd01a04a0f7ce7a66ef4cfc29a72fab.jpeg",
    "https://cdn.faire.com/fastly/229cc3c99bf22bcc5fd21f7032a2771fffe4bd0925a18847f379bce6b2b40e09.jpeg",
  ],
  priceDollars: 3.81,
  description:
    '•\tHandcrafted – made in small batches.\n•\tSpicy – made with our own blend of mild chili powder, dehydrated lime juice and a touch of sea salt.\n•\tNatural Ingredients – Colored with turmeric, beet powder, annatto & spirulina extract. Flavored with Natural Fruit flavors.\n\n"Non-GMO"/ "Free of Bioengineered Ingredients"\n"Vegan" / "Vegan Compliant" / "Made with 100% Vegan ingredients"\n"Allergen Free" / "Free of the top 9 Major Allergens" / "Produced in an Allergen-Free Facility"\n"Gluten Free"  Kosher\n\nThere is a Town called Loma Bonita in the state of Oaxaca Mexico, that is all about Pineapple. Something about the soil, the weather and the warm people that make Loma Bonita home to the sweetest pineapple in the country. Its actually called \'Piña Miel which means honey pineapple because its so sweet.  Naturally flavored and colored ribbon style candy filled with our own blend of mild chili powder, dehydrated lime juice and a touch of sea salt. \n\n',
  tags: [],
  msrpDollars: 6.91,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:48:35.192Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
